import { useState } from 'react';
import { ChungTu, DonViChiNhanh, KhachHang, QuyenChungTu } from '@/types/schemas';

/**
 * Hook for managing search field states in the kiem-tra-tinh-trang-hoa-don-dien-tu feature
 *
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = () => {
  // Document type state
  const [documentType, setDocumentType] = useState<ChungTu | null>(null);

  // Authorization code state
  const [authorizationCode, setAuthorizationCode] = useState<QuyenChungTu | null>(null);

  // Customer state
  const [customer, setCustomer] = useState<KhachHang | null>(null);

  // Unit state
  const [unit, setUnit] = useState<DonViChiNhanh | null>(null);

  return {
    documentType,
    setDocumentType,
    authorizationCode,
    setAuthorizationCode,
    customer,
    setCustomer,
    unit,
    setUnit
  };
};
